import { IOProps } from 'react-compose-io'
import { Typography, Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { TipoStatusExecucaoCiclo, ExecucaoCiclo } from '../../types/execucaoCicloTypes'
import { cabecalhoValidacaoExecucaoCiclo } from '../../types/tabelaTypes'
import { Tabela } from '../Tabela'
import { customTheme } from '../../styles/customTheme'
import { ValidacaoExecucaoCicloIO } from './ValidacaoExecucaoCiclo.IO'
import { LinhaTabelaValidacaoExecucaoCiclo } from './components/LinhaTabelaValidacaoExecucaoCiclo/LinhaTabelaValidacaoExecucaoCiclo'
import { ModalConfirmacaoValidacao } from './components/ModalConfirmacaoValidacao/ModalConfirmacaoValidacao'

export type ValidacaoExecucaoCicloProps = {
  parceiroId: number
}

export function ValidacaoExecucaoCicloView({ _io }: IOProps<ValidacaoExecucaoCicloIO, ValidacaoExecucaoCicloProps>) {
  const classes = _io.styles()
  const [filtroCicloId, setFiltroCicloId] = React.useState('')
  const [filtroStatus, setFiltroStatus] = React.useState('')
  const [filtroDataInicio, setFiltroDataInicio] = React.useState('')
  const [filtroDataFim, setFiltroDataFim] = React.useState('')
  const location = useLocation()

  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    const cicloIdParam = params.get('cicloId') || ''
    const dataInicioParam = params.get('dataInicio') || ''
    const dataFimParam = params.get('dataFim') || ''
    const statusParam = params.get('status') || ''
    if (cicloIdParam) setFiltroCicloId(String(cicloIdParam))
    if (dataInicioParam) setFiltroDataInicio(String(dataInicioParam))
    if (dataFimParam) setFiltroDataFim(String(dataFimParam))
    if (statusParam !== '') setFiltroStatus(String(statusParam))

    if (location.search) {
      _io.buscarExecucoesCiclo({ pageNumber: 1, pageSize: 10 })
    }
  }, [location.search])

  const limparFiltros = () => {
    setFiltroCicloId('')
    setFiltroStatus('')
    setFiltroDataInicio('')
    setFiltroDataFim('')
  }

  const execucoesFiltradas = (_io.execucoesCiclo?.itens ?? []).filter((item) => {
    const cicloIdMatch = filtroCicloId ? String(item.cicloId).includes(filtroCicloId) : true
    const statusMatch = filtroStatus ? String(item.status) === filtroStatus : true

    const inicioItem = (item.dataInicialAjustada as any) || (item.dataInicialOriginal as any)
    const fimItem = (item.dataFinalAjustada as any) || (item.dataFinalOriginal as any)

    const inicioFiltroOk = filtroDataInicio ? new Date(inicioItem) >= new Date(`${filtroDataInicio}T00:00:00`) : true
    const fimFiltroOk = filtroDataFim ? new Date(fimItem) <= new Date(`${filtroDataFim}T23:59:59`) : true

    return cicloIdMatch && statusMatch && inicioFiltroOk && fimFiltroOk
  })

  return (
    <Box className={classes.Container}>
      <Box className={classes.TituloContainer}>
        <Typography variant="h5" style={{ color: customTheme.colors.grey23 }}>
          Validação de Execução de Ciclo
        </Typography>
      </Box>
      <Box mb={2}>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Ciclo ID"
              variant="outlined"
              fullWidth
              value={filtroCicloId}
              onChange={(e) => setFiltroCicloId(e.target.value)}
              placeholder="Digite o cicloId"
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Data Início"
              variant="outlined"
              fullWidth
              type="date"
              value={filtroDataInicio}
              onChange={(e) => setFiltroDataInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Data Fim"
              variant="outlined"
              fullWidth
              type="date"
              value={filtroDataFim}
              onChange={(e) => setFiltroDataFim(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="status-label">Status</InputLabel>
              <Select labelId="status-label" label="Status" value={filtroStatus} onChange={(e) => setFiltroStatus(String(e.target.value))}>
                <MenuItem value="">
                  <em>Todos</em>
                </MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.Novo)}>Novo</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.ErroAquivo)}>ErroArquivo</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.ErroValidacao)}>ErroValidacao</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.Validado)}>Validado</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.Divergente)}>Divergente</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.Rejeitado)}>Rejeitado</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.Aprovado)}>Aprovado</MenuItem>
                <MenuItem value={String(TipoStatusExecucaoCiclo.Sucesso)}>Sucesso</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button onClick={limparFiltros} color="primary">
                Limpar filtros
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box mt={3}>
        {execucoesFiltradas.length === 0 ? (
          <Typography variant="h6" style={{ color: customTheme.colors.grey21, justifyContent: 'space-between', display: 'flex' }}>
            Nenhuma Execução encontrada...
          </Typography>
        ) : (
          <Tabela
            cabecalho={cabecalhoValidacaoExecucaoCiclo}
            itensLista={execucoesFiltradas}
            LinhaTabela={({ item }: { item: ExecucaoCiclo }) => (
              <LinhaTabelaValidacaoExecucaoCiclo item={item} onAceitar={_io.handleAceitar} onRejeitar={_io.handleRejeitar} />
            )}
            orderCampoPadrao=""
            rowsPerPageOptions={[10, 25, 50]}
            linhasPorPaginaPadrao={10}
            alinharTextoCentro={true}
            buscarItensTabela={_io.buscarExecucoesCiclo}
            totalItens={execucoesFiltradas.length}
            semPaginacao={false}
            desabilitarOrdenacao={true}
          />
        )}
      </Box>

      <ModalConfirmacaoValidacao
        open={_io.modalConfirmacao.open}
        execucao={_io.modalConfirmacao.execucao}
        tipoAcao={_io.modalConfirmacao.tipoAcao}
        onClose={_io.fecharModalConfirmacao}
        onConfirmar={_io.confirmarAcao}
        loading={_io.loading}
      />
    </Box>
  )
}
